import type { SupabaseClient } from '@supabase/supabase-js';

import { createClient } from '@supabase/supabase-js';

import { CONFIG } from '@/config-global';

// ----------------------------------------------------------------------

const isSupabase = CONFIG.auth.method === 'supabase';

const supabaseUrl = CONFIG.supabase.url;
const supabaseKey = CONFIG.supabase.key;

export const supabase = isSupabase
  ? createClient(supabaseUrl, supabaseKey)
  : ({} as SupabaseClient<any, 'public', any>);

// ----------------------------------------------------------------------

// Buckets
export const PRIVATE_BUCKET = 'bonni-private';
export const PUBLIC_BUCKET = 'bonni';

type UploadOptions = {
  cacheControl?: string;
  upsert?: boolean;
  contentType?: string;
};

export async function storageUploadFile(
  bucket: string,
  path: string,
  file: File | Blob | ArrayBuffer,
  options?: UploadOptions
) {
  console.log('storageUploadFile', bucket, path, file, options);
  if (!isSupabase) throw new Error('Supabase is not enabled');
  const { data, error } = await supabase.storage.from(bucket).upload(path, file as any, options);
  if (error) throw error;
  return data;
}

export function storageGetPublicUrl(
  bucket: string,
  path: string,
  options?: { transform?: { width?: number; height?: number; resize?: 'cover' | 'contain' | 'fill'; quality?: number; format?: 'origin' | 'webp' | 'avif' } }
) {
  if (!isSupabase) throw new Error('Supabase is not enabled');
  const { data } = supabase.storage.from(bucket).getPublicUrl(path, options as any);
  return data.publicUrl;
}
